import "moment/locale/it";

import * as React from "react";

import { Admin, Loading, Resource, RouteWithoutLayout } from "react-admin";
import {
  WorkflowProvider,
  createI18nProvider,
  useAuthProvider,
  useDataProvider,
  useI18nCatcher,
  useI18nLanguages,
} from "ra-friendsofbabba";

import { API_URL } from "./config";
import Layout from "./component/Layout";
import LoginPage from "./component/page/LoginPage";
import ProfilePage from "./component/page/ProfilePage";
import { Route } from "react-router-dom";
import SignupPage from "./component/page/SignupPage";
import itLanguageMessages from "ra-language-italian";
import languageMessages from "./language-messages";
import notifications from "./notifications";
import pages from "./pages";
import projectDocs from "./project-docs";
import projectMedia from "./project-media";
import projects from "./projects";
import theme from "./theme";
import users from "./users";

const App = () => {
  const apiUrl = API_URL;
  const dataProvider = useDataProvider({
    apiUrl,
    fileFields: ["media", "media_collection"],
  });
  const authProvider = useAuthProvider({ apiUrl });
  const languages = useI18nLanguages({ apiUrl });
  useI18nCatcher({ apiUrl });

  if (languages?.loading) {
    return (
      <Loading loadingPrimary="Loading" loadingSecondary="Please wait..." />
    );
  }

  return (
    <WorkflowProvider apiUrl={apiUrl}>
      <Admin
        title="stradaperstrada.dev"
        theme={theme}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={createI18nProvider({
          languages: {
            ...languages?.data,
            it: {
              ...languages?.data?.it,
              ...itLanguageMessages,
            },
          },
          locale: "it",
        })}
        loginPage={LoginPage}
        layout={Layout}
        customRoutes={[
          <Route
            key="user-profile"
            path="/user-profile"
            component={ProfilePage}
          />,
          <RouteWithoutLayout
            key="signup"
            path="/signup"
            component={SignupPage}
          />,
        ]}
      >
        <Resource name="notifications" {...notifications} />
        <Resource name="users" {...users} />
        <Resource name="user-profile-logs" />
        <Resource name="pages" {...pages} />
        <Resource name="language-messages" {...languageMessages} />
        <Resource name="roles" />
        <Resource name="resources" />
        <Resource name="groups" />
        <Resource name="languages" />
        <Resource name="profile" />
        <Resource name="municipalities" />
        <Resource name="project-doc-types" />
        <Resource name="projects" {...projects} />
        <Resource name="project-docs" {...projectDocs} />
        <Resource name="project-media" {...projectMedia} />
        <Resource name="user-logs" />

        <Resource name="workflow/transactions/tickets" />
        <Resource name="workflow/transactions/projects" />
      </Admin>
    </WorkflowProvider>
  );
};
export default App;
